export default __webpack_public_path__ + "static/media/upload.d17848d8.svg";